import React from "react";
import { lePetitPrinceImages } from "../../../../../../Assets/images/le-petit-prince";
import StyledDiv from "../../../../../StyledDiv/StyledDiv";
import { IStyledDivStyles } from "../../../../../StyledDiv/StyledDiv";

interface IGlobeYellowSingleLittleProps {
  styles?: IStyledDivStyles;
}

const GlobeYellowSingleLittle = ({ styles }: IGlobeYellowSingleLittleProps) => {
  return (
    <StyledDiv styles={styles} className="globe-yellow-single-little">
      <img
        src={lePetitPrinceImages.globeYellowSingleLittle}
        alt="Yellow globe single little"
        style={{ width: "auto", height: "auto" }}
      />
    </StyledDiv>
  );
};

export default GlobeYellowSingleLittle;
